const release = '0.14.0'

module.exports = { release }



// WEBPACK FOOTER //
// ./release.js